module.exports = __webpack_public_path__ + "media/School.5895caf0.svg";